import images from "../../../constant/images";
import { Nav } from "../../../layouts/navbar/nav";
import { partenaireData } from "../../../json/partenairesData";
import Sidebar from "../../../layouts/sidebar/sidebar";
import React, { useEffect, useState, useCallback } from "react";
import { useSelector } from "react-redux";
import axios from "axios";
import { useTranslation } from "react-i18next";

export default function Deals() {
  const { i18n, t } = useTranslation();
  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
  };
  const language = localStorage.getItem("i18nextLng");
  const baseUrl = useSelector((state) => state.gtm.baseUrl);
  const [discounts, setDiscounts] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  const fetchDiscounts = useCallback(async () => {
    try {
      const response = await axios.get(`${baseUrl}/discounts`);
      setDiscounts(response.data.discounts || []);
    } catch (error) {
      console.error("Failed to fetch discounts:", error);
    } finally {
      setIsLoading(false);
    }
  }, [baseUrl]);

  useEffect(() => {
    fetchDiscounts();
  }, [fetchDiscounts]);

  return (
    <div className="bg-white bg-opacity-[87%] shadow-custom h-full flex flex-col justify-center items-center p-6 md:p-16 gap-4 md:gap-8 w-full md:w-[100%] rounded-3xl py-8 md:py-12">
      <div className="text-center text-3xl md:text-4xl font-bold mb-2 md:mb-3">
        <p>{t("partner.partner_deals")}</p>
      </div>
      <div className="text-center w-full h-full flex flex-col gap-6 md:gap-12">
        <span className="text-xl md:text-2xl">
          {t("partner.p1")} <strong>{t("partner.savings_message")}</strong>{" "}
          {t("partner.p2")} <br className="hidden md:block" />
          {t("partner.p3")}
        </span>

        {isLoading ? (
          <div className="flex justify-center items-center h-64">
            <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-gray-900"></div>
          </div>
        ) : discounts.length === 0 ? (
          <p className="text-lg md:text-xl text-gray-600">
            {t("twichiyat.no_deals")}
          </p>
        ) : (
          <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-8">
            {discounts?.map((item) => (
              <div
                key={item.id}
                className="relative flex justify-start items-center rounded-[1000px] bg-white p-3 md:p-4 h-[100px] w-[100px] md:h-[150px] md:w-[150px] mx-auto shadow-md"
              >
                <img
                  src={item.logo}
                  alt="Partner Logo"
                  className="h-full w-full object-contain"
                />
                <span className="absolute bottom-[-6px] md:bottom-[-8px] left-0 w-full bg-gtm-green text-white text-[10px] md:text-xs font-bold p-1 rounded-lg text-center">
                  {item.percantage === null
                    ? `${
                        language === "fr"
                          ? item.fr_description
                          : item.description
                      }`
                    : `${item.percantage}%`}
                </span>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );

  // return (
  //   <div
  //     className="flex flex-col gap-12 min-h-screen"
  //     style={{
  //       backgroundImage: `url(${images.golf_field})`,
  //       backgroundPosition: "center",
  //       backgroundSize: "cover",
  //       backgroundRepeat: "no-repeat",
  //     }}
  //   >
  //     <Nav />
  //     <div className="flex justify-center mx-16 mb-20">
  //       <div className="flex w-full  justify-between items-start">
  //         <Sidebar />
  //         <div className="bg-white bg-opacity-[87%] h-full flex flex-col justify-center items-center p-16 gap-8 w-[75%] rounded-3xl py-16">
  //           <div className="text-center text-6xl font-bold mb-3">
  //             <p>PARTNER DEALS</p>
  //           </div>
  //           <div className="text-center w-full h-full flex flex-col gap-12">
  //             <span className="text-3xl">
  //               Save <strong>up to 20%</strong> with our trusted partners.{" "}
  //               <br />
  //               Exclusive deals await!
  //             </span>

  //             {isLoading ? (
  //               <p className="text-xl text-gray-600">Loading offers...</p>
  //             ) : discounts.length === 0 ? (
  //               <p className="text-xl text-gray-600">No deals available.</p>
  //             ) : (
  //               <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-8">
  //                 {discounts?.map((item) => (
  //                   <div
  //                     key={item.id}
  //                     className="relative flex justify-start items-center rounded-[1000px] bg-white p-4 h-[150px] w-[150px] mx-auto shadow-md"
  //                   >
  //                     <img
  //                       src={ item.logo }
  //                       alt="Partner Logo"
  //                       className="h-full w-full object-contain"
  //                     />
  //                     <span className="absolute bottom-[-8px] left-0 w-full bg-gtm-green text-white text-xs font-bold p-1 rounded-lg text-center">
  //                       {item.percantage}%
  //                     </span>
  //                   </div>
  //                 ))}
  //               </div>
  //             )}
  //           </div>
  //         </div>
  //       </div>
  //     </div>
  //   </div>
  // );
}
